<template>
    <div class="class-stats-page" v-wechat-title="`结对班级统计_双优云桥-智慧研修平台`">
        <div class="class-wrap">
            <div class="crumb-bar">
                <a href="javascript:;" @click.prevent="goHome">项目首页</a>
                <span class="sep">/</span>
                <span class="cur">结对班级统计</span>
            </div>

            <div class="panel" v-loading="filterLoading">
                <div class="panel-hd">
                    <h2>班级列表</h2>
                    <div class="toolbar">
                        <div class="filter-tabs">
                            <button
                                v-for="tab in spaceFilters"
                                :key="tab.key"
                                type="button"
                                class="filter-tab"
                                :class="{ 'is-active': activeSpace === tab.key }"
                                @click="onSpaceFilterChange(tab.key)"
                            >{{ tab.name }}</button>
                        </div>
                        <label class="search-box">
                            <i class="el-icon-search"></i>
                            <input
                                v-model.trim="keyword"
                                type="search"
                                placeholder="搜索结对班级"
                                @keyup.enter="onSearch"
                            />
                        </label>
                        <button type="button" class="btn btn-ghost" @click="exportData">导出数据</button>
                    </div>
                </div>

                <div class="table-scroll" v-loading="listLoading">
                    <table class="data-table">
                        <thead>
                            <tr>
                                <th>结对班级</th>
                                <th>所属校级空间名称</th>
                                <th>成员数</th>
                                <th>课程</th>
                                <th>作业</th>
                                <th>观思问</th>
                                <th>成果</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="row in tableData" :key="row.spaceId || row.name">
                                <td class="name-cell">{{ row.name }}</td>
                                <td>{{ row.space || '--' }}</td>
                                <td>{{ row.members }}</td>
                                <td>{{ row.courses }}</td>
                                <td>{{ row.works }}</td>
                                <td>{{ row.gsw }}</td>
                                <td>{{ row.results }}</td>
                            </tr>
                            <tr v-if="!listLoading && tableData.length === 0">
                                <td colspan="7" class="empty-cell">
                                    <ph-empty
                                        size="table"
                                        :text="keyword || activeSpace !== 'all' ? '未找到匹配的班级' : '暂无班级数据'"
                                        :subtext="keyword ? '请尝试更换搜索关键词或筛选条件' : ''"
                                    />
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>

                <div class="pager-wrap" v-if="pages.total > 0">
                    <pagination
                        :total="pages.total"
                        :page.sync="pages.currentPage"
                        :limit.sync="pages.pageSize"
                        @pagination="handlePageChange"
                    />
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { mapState } from 'vuex'
import pagination from '@/common/community/pagination.vue'
import PhEmpty from './components/ph-empty.vue'

export default {
    name: 'ProjectHomeClassStats',
    components: { pagination, PhEmpty },
    data() {
        return {
            keyword: '',
            activeSpace: 'all',
            filterLoading: false,
            listLoading: false,
            spaceFilters: [
                { key: 'all', name: '全部空间', parentIds: [] }
            ],
            tableData: [],
            pages: {
                currentPage: 1,
                pageSize: 10,
                total: 0
            },
            searchTimer: null
        }
    },
    computed: {
        ...mapState({
            currentProject: state => state.user.currentProject
        }),
        projectId() {
            return this.$route.params.id
        },
        canFetchStats() {
            return [4, 5, 6, 9].includes(Number(this.currentProject && this.currentProject.modelType))
        },
        activeParentIds() {
            const tab = this.spaceFilters.find(item => item.key === this.activeSpace)
            return (tab && tab.parentIds) || []
        }
    },
    watch: {
        keyword() {
            clearTimeout(this.searchTimer)
            this.searchTimer = setTimeout(() => {
                this.pages.currentPage = 1
                this.fetchClassSpaces()
            }, 300)
        },
        'currentProject.modelType'() {
            this.initPage()
        },
        '$route.params.id'() {
            this.initPage()
        }
    },
    methods: {
        toStatNumber(val) {
            const n = Number(val)
            return Number.isFinite(n) ? n : 0
        },
        formatPairingClass(val) {
            if (!val) return '--'
            return String(val)
        },
        mapClassSpaceRow(item) {
            return {
                spaceId: item.spaceId,
                name: this.formatPairingClass(item.pairingClass),
                space: item.parentSpaceName || '',
                members: this.toStatNumber(item.memberCount),
                courses: this.toStatNumber(item.courseCount),
                works: this.toStatNumber(item.homeworkCount),
                gsw: this.toStatNumber(item.gswCount),
                results: this.toStatNumber(item.resourceCount)
            }
        },
        goHome() {
            this.$router.push(`/projectHome/${this.projectId}`)
        },
        exportData() {
            this.$message.info('导出数据功能暂未接入接口')
        },
        onSearch() {
            clearTimeout(this.searchTimer)
            this.pages.currentPage = 1
            this.fetchClassSpaces()
        },
        onSpaceFilterChange(key) {
            if (this.activeSpace === key) return
            this.activeSpace = key
            this.pages.currentPage = 1
            this.fetchClassSpaces()
        },
        handlePageChange(data) {
            this.pages.currentPage = data.pageIndex
            this.pages.pageSize = data.pageSize
            this.fetchClassSpaces()
        },
        async fetchSpaceFilters() {
            if (!this.projectId || !this.canFetchStats) {
                this.spaceFilters = [{ key: 'all', name: '全部空间', parentIds: [] }]
                this.activeSpace = 'all'
                return
            }
            this.filterLoading = true
            try {
                const res = await this.$Api.Paired.getProjectSchoolSpaces({
                    projectId: this.projectId,
                    page: 1,
                    limit: 200
                })
                const records = ((res && res.data && res.data.records) || [])
                this.spaceFilters = [
                    { key: 'all', name: '全部空间', parentIds: [] },
                    ...records.map(item => ({
                        key: String(item.spaceId),
                        name: item.spaceName || `空间${item.spaceId}`,
                        parentIds: item.spaceId != null ? [item.spaceId] : []
                    }))
                ]
                if (!this.spaceFilters.some(item => item.key === this.activeSpace)) {
                    this.activeSpace = 'all'
                }
            } catch (e) {
                this.spaceFilters = [{ key: 'all', name: '全部空间', parentIds: [] }]
                this.activeSpace = 'all'
            } finally {
                this.filterLoading = false
            }
        },
        async fetchClassSpaces() {
            if (!this.projectId || !this.canFetchStats) {
                this.tableData = []
                this.pages.total = 0
                return
            }
            this.listLoading = true
            try {
                const params = {
                    projectId: this.projectId,
                    page: this.pages.currentPage,
                    limit: this.pages.pageSize
                }
                const parentIds = this.activeParentIds
                if (parentIds.length) {
                    params.parentIds = parentIds
                }
                if (this.keyword) {
                    params.spxName = this.keyword
                }
                const res = await this.$Api.Paired.getProjectClassSpaces(params)
                const data = (res && res.data) || {}
                this.tableData = (data.records || []).map(item => this.mapClassSpaceRow(item))
                this.pages.total = this.toStatNumber(data.total)
            } catch (e) {
                this.tableData = []
                this.pages.total = 0
            } finally {
                this.listLoading = false
            }
        },
        async initPage() {
            this.pages.currentPage = 1
            this.keyword = ''
            await this.fetchSpaceFilters()
            await this.fetchClassSpaces()
        }
    },
    mounted() {
        this.initPage()
    },
    beforeDestroy() {
        clearTimeout(this.searchTimer)
    }
}
</script>

<style lang="less" scoped>
.class-stats-page {
    background: #f5f7fa;
    min-height: 60vh;
    padding: 24px 0 48px;
    line-height: 1.5;
}

.class-wrap {
    width: 990px;
    max-width: 100%;
    margin: 0 auto;
    box-sizing: border-box;
}

.crumb-bar {
    font-size: 13px;
    color: #999;
    margin-bottom: 16px;

    a {
        color: #01A2FD;
        text-decoration: none;
    }

    .sep {
        margin: 0 8px;
        color: #ccc;
    }

    .cur {
        color: #666;
    }
}

.btn {
    height: 34px;
    padding: 0 16px;
    border-radius: 4px;
    font-size: 13px;
    font-family: inherit;
    cursor: pointer;
    border: 1px solid transparent;
    line-height: 1;
}

.btn-ghost {
    background: #fff;
    border-color: #dcdfe6;
    color: #666;

    &:hover {
        color: #01A2FD;
        border-color: #01A2FD;
    }
}

.panel {
    background: #fff;
    border: 1px solid rgba(199, 199, 199, 0.4);
    border-radius: 4px;
    overflow: hidden;
    min-height: 240px;
}

.panel-hd {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 16px;
    padding: 0 20px;
    line-height: 56px;
    border-bottom: 1px solid rgba(199, 199, 199, 0.4);
    background: rgba(250, 251, 255, 1);
    flex-wrap: wrap;

    h2 {
        margin: 0;
        font-size: 16px;
        font-weight: 400;
        color: #333;
        white-space: nowrap;
    }
}

.toolbar {
    display: flex;
    align-items: center;
    gap: 16px;
    flex-wrap: wrap;
    min-width: 0;
}

.filter-tabs {
    display: flex;
    flex-wrap: wrap;
    gap: 0;
    max-width: 640px;
}

.filter-tab {
    padding: 0 12px;
    height: 56px;
    border: none;
    background: transparent;
    color: #666;
    font-size: 13px;
    cursor: pointer;
    position: relative;
    font-family: inherit;
    white-space: nowrap;
    max-width: 160px;
    overflow: hidden;
    text-overflow: ellipsis;

    &:hover,
    &.is-active {
        color: #01A2FD;
    }

    &.is-active::after {
        content: "";
        position: absolute;
        left: 10px;
        right: 10px;
        bottom: 0;
        height: 2px;
        background: #01A2FD;
        border-radius: 1px;
    }
}

.search-box {
    display: inline-flex;
    align-items: center;
    gap: 8px;
    height: 34px;
    padding: 0 12px;
    border: 1px solid #e0e6ed;
    border-radius: 4px;
    background: #fff;
    box-sizing: border-box;

    i {
        color: #999;
        font-size: 14px;
    }

    input {
        border: none;
        outline: none;
        width: 160px;
        font-size: 13px;
        color: #333;
        background: transparent;
        font-family: inherit;

        &::placeholder {
            color: #bbb;
        }
    }
}

.table-scroll {
    overflow-x: auto;
}

.data-table {
    width: 100%;
    border-collapse: collapse;
    font-size: 13px;

    th {
        text-align: left;
        padding: 14px;
        background: #fafbff;
        color: #666;
        font-weight: 400;
        white-space: nowrap;
    }

    td {
        padding: 14px;
        color: #555;
        border-bottom: 1px solid #f5f7fa;
        vertical-align: middle;
    }

    tbody tr:hover td:not(.empty-cell) {
        background: #EAF6FF;
    }

    .name-cell {
        color: #333;
        font-weight: 500;
        min-width: 200px;
    }

    .empty-cell {
        padding: 0;
        border-bottom: none;
        background: transparent !important;
    }
}

.pager-wrap {
    padding: 8px 16px 16px;
}

@media screen and (min-width: 1250px) {
    .class-wrap {
        width: 1200px;
    }
}
</style>
